import { render, staticRenderFns } from "./NewFeaturesControl.vue?vue&type=template&id=34bae710&scoped=true"
import script from "./NewFeaturesControl.vue?vue&type=script&lang=js"
export * from "./NewFeaturesControl.vue?vue&type=script&lang=js"
import style0 from "./NewFeaturesControl.vue?vue&type=style&index=0&id=34bae710&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bae710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34bae710')) {
      api.createRecord('34bae710', component.options)
    } else {
      api.reload('34bae710', component.options)
    }
    module.hot.accept("./NewFeaturesControl.vue?vue&type=template&id=34bae710&scoped=true", function () {
      api.rerender('34bae710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/NewFeaturesControl.vue"
export default component.exports